import graphql from './graphql';

const mutation = /* GraphQL */ `
  mutation Module_create($courseId: ID!) {
    Module_create(courseId: $courseId) {
      name
      isDraft
      order
      id
    }
  }
`;

const moduleCreate = async courseId =>
  // eslint-disable-next-line camelcase
  graphql(mutation, { courseId }).then(({ Module_create }) => Module_create);
export default moduleCreate;
